import { useState } from "react";
import { Box, Tooltip, Button } from "@mui/material";

const API = process.env.REACT_APP_API_URL;

export default function AttachmentPreview({ file }) {
  const [preview, setPreview] = useState(null);

  const loadPreview = async () => {
    if (preview) return; // ya cargada

    const res = await fetch(`${API}/emails/attachment/${file.id}/preview`);
    const blob = await res.blob();
    setPreview(URL.createObjectURL(blob));
  };

  return (
    <Tooltip
      title={
        preview ? (
          file.filename.toLowerCase().endsWith(".pdf") ? (
            <embed
              src={preview}
              type="application/pdf"
              width="340"
              height="400"
              style={{ borderRadius: 6 }}
            />
          ) : (
            <img
              src={preview}
              width="340"
              alt="preview"
              style={{ borderRadius: 6 }}
            />
          )
        ) : (
          "Cargando..."
        )
      }
      onOpen={loadPreview} // carga cuando hace hover
      arrow
      placement="right"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "white",
            color: "black",
            boxShadow: "0px 3px 12px rgba(0,0,0,0.25)",
            borderRadius: "8px",
            p: 1,
          },
        },
      }}
    >
      <Button
        variant="outlined"
        size="small"
        href={`${API}/emails/attachment/${file.id}/download`}
        onClick={(e) => e.stopPropagation()}
      >
        📎 {file.filename}
      </Button>
    </Tooltip>
  );
}
